import React, { PureComponent, PropTypes } from 'react';
import { AutoSizer } from 'react-virtualized';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import GoogleMapReact from 'google-map-react';
import { fitBounds } from 'google-map-react/utils';
import CONFIG from '../../config';


class LatLngBounds {
  bounds = null;

  extend(lat, lng) {
    if (!this.bounds) {
      this.bounds = {
        sw: {lat, lng},
        ne: {lat, lng}
      }
    } else {
      this.bounds = {
        sw: {
          lat: Math.min(this.bounds.sw.lat, lat),
          lng: Math.min(this.bounds.sw.lng, lng),
        },
        ne: {
          lat: Math.max(this.bounds.ne.lat, lat),
          lng: Math.max(this.bounds.ne.lng, lng),
        }
      }
    }

    return this;
  }
}

class ObjectPoint extends PureComponent {
  render() {
    const { id, type, hilighted, products, code } = this.props;
    const product = products[0];
    const link = product
      ? `/browse/${id}/${product.id}/`
      : `/browse/${id}/`;

    return (
      <div className={classNames('point', type, { active: hilighted })}>
        <Link to={link}>
          { type === 'pale'
            ? (<span className="code">{code}</span>)
            : (<i className={`icon ${type}`} />)
          }
        </Link>
      </div>
    );
  }
}

const defaultCenter = {
  lat: 56.940725,
  lng: 24.1451949
};

class MapContainer extends PureComponent {
  static propTypes = {
    items: PropTypes.array.isRequired,
    hilighted: PropTypes.number,
    center: PropTypes.object,
    size: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    })
  };


  getDims() {
    const {items, center, size} = this.props;
    
    if (center) {
      return {center: center, zoom: 14 }
    }

    if (items.length === 1) {
      return {
        center: {
          lat: items[0].lat,
          lng: items[0].lng
        }
      }
    } else if (items.length > 0) {
      const bounds = new LatLngBounds();
      items.forEach(({lat, lng}) => {
        bounds.extend(lat, lng);
      });

      const calculatedBounds = fitBounds(bounds.bounds, size);

      return {
        center: calculatedBounds.center,
        zoom: calculatedBounds.zoom
      }
    }
    return {center: defaultCenter, zoom: 15}
  }


  render() {
    const { size, items, hilighted } = this.props;

    return (
      <div style={size}>
        <GoogleMapReact
          defaultCenter={defaultCenter}
          defaultZoom={15}
          bootstrapURLKeys={{key: CONFIG.GOOGLE_MAP_KEY}}
          resetBoundsOnResize={true}
          options={{fullscreenControl: false}}
          {...this.getDims()}
          items={items}
        > 
          {items.map((item, idx) => <ObjectPoint key={idx} {...item} hilighted={hilighted && hilighted === item.id} />)}
        </GoogleMapReact>
      </div>
    )
  }
}

export default class BrowserMap extends PureComponent {
  static propTypes = {
    items: PropTypes.array.isRequired,
    hilighted: PropTypes.number,
    center: PropTypes.object,
  };

  render() {
    return (
      <AutoSizer>
        {size => (size.width && size.height) ? <MapContainer {...this.props} size={size} /> : <span /> }
      </AutoSizer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Browser/BrowserMap.js